import { groupPrintedItemGroups } from '../shared/printedItems';

// Group the view, not the server selection. Pricing/Extras are compared using
// the paid quantities, never the remaining quantities after a previous issue.
export function groupPostpaidReserveItems(items = []) {
  const normalized = items.filter(item => Number(item.quantity) > 0).map(source => {
    const paid = Number(source.paid_quantity ?? source.quantity);
    const original = Number(source.original_quantity ?? paid);
    const row = {
      ...source, quantity: paid, reserveSource: source,
      extras: (source.extras || []).map(extra => ({
        ...extra,
        quantity: Number(extra.quantity ?? 1) * paid / original,
        total_price: Number(extra.total_price ?? Number(extra.price ?? extra.unit_price ?? 0) * Number(extra.quantity ?? 1)) * paid / original,
      })),
    };
    if (source.net_minor != null) row.total_price_with_extras = Number(source.net_minor) / 100;
    return row;
  });
  return groupPrintedItemGroups(normalized).map(({item,members}) => ({
    item: {...item, order_item_id: Number(members[0].id), quantity: members.reduce((sum,line) => sum + Number(line.reserveSource.quantity),0)},
    members: members.map(line => line.reserveSource).sort((a,b) => Number(a.id)-Number(b.id)),
  }));
}

export function groupedReserveValue(value, groups) {
  if (!value || value.mode !== 'issue') return value;
  return {...value, selections: groups.flatMap(group => {
    const ids = new Set(group.members.map(item => String(item.id)));
    const quantity = (value.selections || []).reduce((sum,line) => sum + (ids.has(String(line.lineKey)) ? Number(line.quantity) : 0),0);
    return quantity > 0 ? [{lineKey:String(group.item.order_item_id),quantity}] : [];
  })};
}

export function expandReserveGroupValue(value, groups) {
  if (!value || value.mode !== 'issue') return value;
  const selections = [];
  for (const selected of value.selections || []) {
    const group = groups.find(entry => String(entry.item.order_item_id) === String(selected.lineKey));
    let remaining = Number(selected.quantity);
    if (!group || !Number.isSafeInteger(remaining) || remaining < 0 || remaining > group.item.quantity) throw new Error('Quantité à consigner invalide');
    for (const member of group.members) {
      const quantity = Math.min(remaining, Number(member.quantity));
      if (quantity > 0) selections.push({lineKey:String(member.id),quantity});
      remaining -= quantity;
    }
  }
  return {...value,selections};
}
